<template>
  <Modal @close="onClose()" class="terms-follow-modal">
    <template v-slot:modalcontent>
      <div class="max-w-sm mx-auto modal-content">
        <h3 class="text-center text-lg font-bold">Topics to follow</h3>
        <OrbitTerms :params="params">
          <template v-slot:whenempty>
            <p class="my-4 text-center ui-font">Could not find any topics.</p>
          </template>
        </OrbitTerms>
      </div>
    </template>
  </Modal>
</template>
<script>
import { useQueryClient } from "vue-query";
import OrbitTerms from "@/lib/OrbitTerms.vue";
import { defineAsyncComponent, onUnmounted } from "vue";

const Modal = defineAsyncComponent(() =>
  import(/* webpackChunkName: "Chunks1" */ "@/lib/Modal.vue"),
);

export default {
  name: "TermsFollowModal",
  props: {
    onClose: Function,
  },
  components: {
    Modal,
    OrbitTerms,
  },
  setup() {
    const params = {
      per_page: 25,
      orderby: "name",
      pagination: 1,
      _fields: ["id", "name", "taxonomy", "is_following"],
      style: "TermsFollowChips",
      pagination_style: "loadMore",
    };

    const queryClient = useQueryClient();

    onUnmounted(() => {
      queryClient.removeQueries({ queryKey: ["OrbitQuery", params] }); // CLEAR CACHED DATA
    });

    return { params };
  },
};
</script>
<style>
.terms-follow-modal .modal,
.terms-follow-modal .modal-body {
  overflow-y: auto;
}

.terms-follow-modal .load-more-btn-wrapper {
  @apply text-center mt-7;
}

.terms-follow-modal .load-more-btn {
  @apply bg-yka-blue rounded-full;
}

@media (min-width: 1024px) {
  .terms-follow-modal .modal {
    height: 29.5rem;
    overflow: hidden;
  }

  .terms-follow-modal .modal-body {
    height: 26rem;
  }
}
</style>
